<template>
    <div class="about-me">
        <div class="about-grid">
          <ul class="about-grid__ul">
            <li class="about-grid__li" :key="item" v-for="item in personalInfo">
              <b class="about-grid__b">{{item.name}}:</b>  <router-link class="about-grid__a" :to="{ name: item.router }"  v-if="item.link"
              > {{item.data}} </router-link
            > <span v-else>{{item.data}}</span> 
            </li>
      
          </ul>
          <div class="about-percentages">
            <div class="percentage" :key="item" v-for="item in percentages">
              <div class="percentage-title">
                <h4>{{item.name}}</h4>
                <h4>{{item.width}}</h4>
              </div>
              <div class="percentage-bar">
                <div class="width-bar" :style="{width: item.width}"></div>
              </div>
            </div>
 
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GridAbout',
    props:{
        personalInfo: Array,
        percentages: Array,
    }
}
</script>

<style>

</style>